module.exports = __webpack_public_path__ + "img/card_230150655.f3d4d1fb.jpg";